import type {
  Insights,
  NotificationIndicator,
} from '~/types/rental-api-aliases'

export const DEFAULT_INSIGHTS: Insights = {
  HasPayoutInfoSet: false,
  IsSuperHost: false,
  PerformanceTier: 'New',
  UpdatedAt: '',
} as const
Object.freeze(DEFAULT_INSIGHTS)
export type DEFAULT_INSIGHTS = (typeof DEFAULT_INSIGHTS)[keyof typeof DEFAULT_INSIGHTS]

export const DEFAULT_NOTIFICATIONS: NotificationIndicator = {
  Counts: {},
} as const
Object.freeze(DEFAULT_NOTIFICATIONS)
export type DEFAULT_NOTIFICATIONS = (typeof DEFAULT_NOTIFICATIONS)[keyof typeof DEFAULT_NOTIFICATIONS]
